import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Popup, Icon, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import * as common from 'libs/commonFunc';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { target, selectDeclareTargetNo, handleSelectDeclare } = this.props;
    const {
      targetNo,
      targetName,
      targetEmail,
      targetPhone,
      targetDivision,
      targetPosition,
      declareCount
    } = target.toJS();

    return (
      <Segment
        vertical
        className={cx('targetItem-wrapper', {
          selected: selectDeclareTargetNo === targetNo
        })}
        onClick={e => {
          e.stopPropagation();
          handleSelectDeclare(targetNo);
        }}>
        <Grid columns="equal" stackable>
          <Grid.Row textAlign="center">
            <Grid.Column className={cx('cell-declare')}>
              <div className={cx('declare-area')}>
                <Tooltip
                  title={
                    defineMessages(formatMessage({ id: 'Declare_12', defaultMessage: '신고 이력' })) +
                    ': ' +
                    declareCount +
                    defineMessages(formatMessage({ id: 'TargetItem_7', defaultMessage: '개' }))
                  }
                  classes={{ tooltip: 'tooltip-noMaxWidth' }}
                  placement="bottom-end">
                  <div className={cx('declare-box existDeclare')}>
                    <span className={cx('declare-title')}>
                      <Image src="/img/declare/declare_on.png" />
                    </span>
                    <span>
                      {declareCount + defineMessages(formatMessage({ id: 'TargetItem_7', defaultMessage: '개' }))}
                    </span>
                  </div>
                </Tooltip>
              </div>
            </Grid.Column>
            <Grid.Column className={cx('cell-targetInfo')} textAlign="left">
              {/* 대상자 정보 */}
              <Popup
                trigger={
                  <div className={cx('targetInfo-area', 'ellipsis')}>
                    <span className={cx('targetName')}>{targetName}</span>
                    <span className={cx('targetEmail ellipsis')}>({targetEmail})</span>
                  </div>
                }
                content={
                  <div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetItem_1', defaultMessage: '대상자 번호' }))}
                      </div>
                      <div className={cx('bold')}>{targetNo}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_21', defaultMessage: '이름' }))}
                      </div>
                      <div className={cx('bold')}>{targetName}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_22', defaultMessage: '이메일' }))}
                      </div>
                      <div className={cx('bold')}>{targetEmail}</div>
                    </div>
                    {!!targetPhone && (
                      <div className={cx('targetInfo-area')}>
                        <div className={cx('targetInfo-title')}>
                          {defineMessages(formatMessage({ id: 'TargetItem_2', defaultMessage: '연락처' }))}
                        </div>
                        <div className={cx('bold')}>{targetPhone}</div>
                      </div>
                    )}
                  </div>
                }
                size="mini"
              />
            </Grid.Column>
            <Grid.Column className={cx('cell-company')}>
              <Popup
                trigger={
                  <div className={cx('target-division', 'ellipsis')}>{targetDivision ? targetDivision : '-'}</div>
                }
                content={
                  <div>
                    <span>{defineMessages(formatMessage({ id: 'TargetItem_3', defaultMessage: '소속' })) + ' '}</span>
                    <span className={cx('bold')}>{targetDivision ? targetDivision : '-'}</span>
                  </div>
                }
                size="mini"
              />
              <Popup
                trigger={
                  <div className={cx('target-position', 'ellipsis')}>{targetPosition ? targetPosition : '-'}</div>
                }
                content={
                  <div>
                    <span>{defineMessages(formatMessage({ id: 'TargetItem_4', defaultMessage: '직급' })) + ' '}</span>
                    <span className={cx('bold')}>{targetPosition ? targetPosition : '-'}</span>
                  </div>
                }
                size="mini"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

DeclareItem.propTypes = {
  target: ImmutablePropTypes.mapContains({
    targetNo: PropTypes.number,
    targetId: PropTypes.string,
    targetName: PropTypes.string,
    targetEmail: PropTypes.string,
    targetPhone: PropTypes.string,
    targetDivision: PropTypes.string,
    targetPosition: PropTypes.string,
    targetDetail: PropTypes.string,
    modifyEpoch: PropTypes.number,
    regEpoch: PropTypes.number
  })
};

export default injectIntl(DeclareItem);



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareItem.js